
const FinalSubmitAndPay = (props:{title:string, className?:string}) => {
     return (  <div>
          <button className={props.className ?? "rounded bg-rose-700 px-8 py-2 text-zinc-50 mb-14"}>
            {props.title}
          </button>
        </div> );
}

export default FinalSubmitAndPay;